@if (isOpen) {
  <div class="dialog-backdrop" (click)="closed.emit()">
    <div class="dialog" (click)="$event.stopPropagation()">
      <h2 class="dialog-title">Apply Template</h2>
      <p class="dialog-body">
        This will replace all views and blocks in your project with <strong>{{ templateName }}</strong>. This action cannot be undone.
      </p>
      <div class="dialog-actions">
        <button class="btn-cancel" (click)="closed.emit()">Keep Current</button>
        <button class="btn-warning" (click)="confirmed.emit()">Apply Template</button>
      </div>
    </div>
  </div>
}
